import React from 'react';
import { css } from "@emotion/core";
import PuffLoader from "react-spinners/PuffLoader";

export default function LoadingPage() {
  const override = css`
    display: flex;
    margin: 0 auto;
  `;
  
  return (
    <div className="sweet-loading">
      <PuffLoader
        css={override}
        size={150}
        color={"#62af42"}
        loading={true}
      />
    </div>
  );
}
